(function () {
  var STORAGE_KEY = 'ownart:wishlist:v1';
  var FAVORITES_PATH = '/pages/favorites';

  function readItems() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (item) {
        return item && item.handle;
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('ownart:wishlist-updated', { detail: { items: items } }));
    } catch (error) {}
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function itemFromCard(card) {
    if (!card) return null;
    var link = card.querySelector('.ownart-commerce__card-inner[href], a[href]');
    var image = card.querySelector('img');
    var title = card.querySelector('h3');
    var brand = card.querySelector('.ownart-commerce__brand');
    var type = card.querySelector('.ownart-commerce__materials');
    var price = card.querySelector('.ownart-commerce__price');
    var url = card.dataset.productUrl || (link ? link.getAttribute('href') : '');
    var handle = card.dataset.productHandle || String(url || '').split('/products/')[1] || '';

    handle = handle.split('?')[0].split('#')[0].replace(/^\/|\/$/g, '');
    if (!handle) return null;

    return {
      handle: handle,
      title: card.dataset.productTitle || (title ? title.textContent.trim() : ''),
      url: url || '/products/' + handle,
      image: card.dataset.productImage || (image ? image.currentSrc || image.src : ''),
      brand: card.dataset.productVendor || (brand ? brand.textContent.trim() : ''),
      type: card.dataset.productType || (type ? type.textContent.trim() : ''),
      price: card.dataset.productPrice || (price ? price.textContent.trim() : '')
    };
  }

  function hasItem(handle) {
    return readItems().some(function (item) {
      return item.handle === handle;
    });
  }

  function setButtonState(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function syncButtons() {
    var items = readItems();
    var handles = items.map(function (item) {
      return item.handle;
    });

    document.querySelectorAll('[data-catalog-favorite]').forEach(function (button) {
      var item = itemFromCard(button.closest('[data-ownart-wishlist-card], [data-catalog-card]'));
      setButtonState(button, !!item && handles.indexOf(item.handle) !== -1);
    });
  }

  function toggleItem(item) {
    if (!item) return;
    var items = readItems();
    var existingIndex = items.findIndex(function (storedItem) {
      return storedItem.handle === item.handle;
    });

    if (existingIndex === -1) {
      items.unshift(item);
    } else {
      items.splice(existingIndex, 1);
    }

    writeItems(items);
    syncButtons();
    renderFavoritesPage();
  }

  function isFavoritesPage() {
    return window.location.pathname.replace(/\/$/, '') === FAVORITES_PATH;
  }

  function renderCard(item) {
    return [
      '<article class="ownart-wishlist-page__item" data-wishlist-item="' + escapeHtml(item.handle) + '">',
      '<a class="ownart-wishlist-page__card" href="' + escapeHtml(item.url || '/products/' + item.handle) + '">',
      '<span class="ownart-wishlist-page__media">',
      item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '',
      '<button class="ownart-wishlist-page__remove" type="button" aria-label="Remove from wishlist" data-wishlist-remove="' + escapeHtml(item.handle) + '">&hearts;</button>',
      '</span>',
      item.brand ? '<span class="ownart-wishlist-page__brand">' + escapeHtml(item.brand) + '</span>' : '',
      item.title ? '<h2 class="ownart-wishlist-page__name">' + escapeHtml(item.title) + '</h2>' : '',
      item.type ? '<span class="ownart-wishlist-page__type">' + escapeHtml(item.type) + '</span>' : '',
      item.price ? '<span class="ownart-wishlist-page__price">' + escapeHtml(item.price) + '</span>' : '',
      '</a>',
      '</article>'
    ].join('');
  }

  function renderFavoritesPage() {
    if (!isFavoritesPage()) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    var items = readItems();
    main.innerHTML = [
      '<section class="ownart-wishlist-page">',
      '<div class="ownart-wishlist-page__header">',
      '<h1 class="ownart-wishlist-page__title">Favorites</h1>',
      '<p class="ownart-wishlist-page__count">' + items.length + ' item' + (items.length === 1 ? '' : 's') + '</p>',
      '</div>',
      items.length
        ? '<div class="ownart-wishlist-page__grid">' + items.map(renderCard).join('') + '</div>'
        : '<div class="ownart-wishlist-page__empty">Your favorites list is empty.</div>',
      '</section>'
    ].join('');
  }

  document.addEventListener('click', function (event) {
    var favorite = event.target.closest('[data-catalog-favorite]');
    if (favorite) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleItem(itemFromCard(favorite.closest('[data-ownart-wishlist-card], [data-catalog-card]')));
      return;
    }

    var remove = event.target.closest('[data-wishlist-remove]');
    if (!remove) return;

    event.preventDefault();
    event.stopPropagation();
    writeItems(readItems().filter(function (item) {
      return item.handle !== remove.getAttribute('data-wishlist-remove');
    }));
    syncButtons();
    renderFavoritesPage();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncButtons();
      renderFavoritesPage();
    });
  } else {
    syncButtons();
    renderFavoritesPage();
  }

  window.addEventListener('ownart:products-updated', syncButtons);
  window.addEventListener('pageshow', syncButtons);
})();
